import { Vector3 } from "three";
import { BasePool } from "./BasePool.js";
/**
 * A pool specifically for managing and reusing instances of `Vector3` objects.
 */
export class Vector3Pool extends BasePool {
    constructor() {
        super(...arguments);
        this._createElementCallback = () => new Vector3();
    }
}
export const vec3Pool = new Vector3Pool();
//# sourceMappingURL=Vector3Pool.js.map